<template>
  <div class="school-container">
    <div class="action-header">
      <el-form :model="postForm" :rules="rules" ref="postForm" class="modal" label-width="100px">
        <el-form-item label="学校名称" prop="name">
          <el-input v-model="postForm.name" />
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="submitForm('postForm')">提交</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="name">
        <template slot="header" slot-scope="scope">
          <div>学校名称</div>
          <el-input
            v-model="search.name"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        prop="createDate">
        <template slot="header" slot-scope="scope">
          <div>创建时间</div>
          <el-input
            v-model="search.createDate"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="240"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- create/edit modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="更新学校信息" center>
      <el-form :model="dialogForm" :rules="rules" ref="dialogForm" class="modal" label-width="100px">
        <el-form-item label="学校名称" prop="loginId">
          <el-input v-model="dialogForm.name"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdateForm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- create/edit modal start -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as moment from 'moment'

import { getSchoolList, addSchool, updateSchool, deleteSchool } from '@/api/site'

export default {
  name: 'Fees',
  data() {
    return {
      list: [],
      postForm: {},
      listLoading: false,
      search: {},
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      dialogVisible: false,
      dialogForm: {},
      rules: {
        name: [
          { required: true, message: '请输入学校名称', trigger: 'blur' },
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  computed: {
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleEdit(index, row) {
      this.dialogForm = Object.assign({}, row)
      this.dialogVisible = true
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该学校, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
       this.deleteSchool(this.list[index].id)
      }).catch(() => {
      })
    },
    // dialog form methods
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addSchool()
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
       getSchoolList(this.listQuery).then(response => {
       const data = response.data
       this.list = data.list
       this.currentPage = data.pageNum
       this.totalCount = data.count
       this.listLoading = false
       })
    },
    addSchool() {
      addSchool(this.postForm).then(response => {
        const data = response.data
        if(data) {
          this.getList()
          this.$message({
            message: '创建成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
      })
    },
    deleteSchool(id) {
      deleteSchool(id).then(response => {
        const data = response.data
        if(data) {
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    updateSchool() {
      const params = {
        id: this.dialogForm.id,
        name: this.dialogForm.name
      }
      updateSchool(params).then(response => {
        const data = response.data
        if(data) {
          this.$message({
            message: '更新成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.dialogVisible = false
          this.dialogForm = {}
          this.getList()
        }
      })
    },
    submitUpdateForm() {
      this.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          this.updateSchool()
        }
      })
    },
    formatDate: function(row, column) {
      const date = row[column.property];
      return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .school-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
      button {
        margin-left: 100px;
      }
    }

    .el-form {
      .el-form-item {
        .el-input {
          width: 400px;
        }
      }
    }

    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }
  }
</style>
